import type { EntityId, RiksjaEnv } from './types.js'

export const apiUrlForEnv: Record<string, string> = {
  dev: 'https://api.riksja-dev.q42labs.com',
  acc: 'https://api-acc.riksjatravel.dev',
  staging: 'https://api-staging.riksjatravel.dev',
  prod: 'https://api.riksjatravel.nl',
}

// The public front-end domain per environment and brand — the host a visitor (or an editor
// checking their work) actually browses. Shared because two sides need the same answer: the web
// app resolves its own canonical base URL from it, and the Studio links editors to the live page.
// `dev` intentionally points at acc: there is no separate dev front-end domain.
export const feUrlForEnv: Record<RiksjaEnv, Record<EntityId, string>> = {
  dev: {
    riksja: 'https://acc.riksjatravel.dev',
    erlebe: 'https://acc.erlebe.dev',
    rickshaw: 'https://acc.rickshawtravel.dev',
  },
  acc: {
    riksja: 'https://acc.riksjatravel.dev',
    erlebe: 'https://acc.erlebe.dev',
    rickshaw: 'https://acc.rickshawtravel.dev',
  },
  staging: {
    riksja: 'https://staging.riksjatravel.dev',
    erlebe: 'https://staging.erlebe.dev',
    rickshaw: 'https://staging.rickshawtravel.dev',
  },
  prod: {
    riksja: 'https://www.riksjatravel.nl',
    erlebe: 'https://www.erlebe.de',
    rickshaw: 'https://www.rickshawtravel.co.uk',
  },
}
